// tslint:disable
export enum EnrollmentState {
    /**
     * @description Running
     */
    Running = 0,
    /**
     * @description Complete
     */
    Complete = 1,
    /**
     * @description Error
     */
    Error = 2,
}
(EnrollmentState as any)['RUNNING'] = 0;
(EnrollmentState as any)['COMPLETE'] = 1;
(EnrollmentState as any)['ERROR'] = 2;
